module.exports = __webpack_public_path__ + "img/hm.ac7ddaca.svg";